<template>
  <div>
    <div class="organisation-actions">
      <div class="organisation-actions-action">
        <div>
          <h6>Deactivate Organisation</h6>
          <p class="sla-text">
            Once an organisation is deactivated, there is no going back.
          </p>
        </div>
        <el-button type="primary" plain @click="showConfirm = true"
          >Deactivate</el-button
        >
      </div>
    </div>
    <el-dialog
      :title="'Deactivate Organisation'"
      :visible.sync="showConfirm"
      width="33%"
      @close="cancel"
    >
      <div class="mb-2">
        <p>
          Are you sure you want to deactivate your organization? All data would
          be lost and cannot be recovered.
        </p>
      </div>
      <p class="mb-1">
        Please type
        <span class="text-primary text-bold">{{
          organisation && organisation.name
        }}</span>
        to confirm
      </p>
      <el-form :model="form" label-position="top">
        <el-form-item label="">
          <el-input v-model="form.organisation" type="text" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button plain size="medium" @click="cancel">Cancel</el-button>
        <el-button
          type="primary"
          size="medium"
          :loading="deactivating"
          :disabled="!valid"
          @click="deactivate"
          >Continue</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as actions from "@/store/action-types";

export default {
  name: "OrganisationActions",
  data() {
    return {
      showConfirm: false,
      form: {
        organisation: ""
      },
      deactivating: false
    };
  },
  computed: {
    valid() {
      const { name } = this.organisation;
      const { organisation } = this.form;
      return name && organisation && name === organisation.trim();
    },
    organisation() {
      return this.$store.getters.organisation.summary;
    }
  },
  methods: {
    cancel() {
      this.showConfirm = false;
      this.form.organisation = "";
    },
    deactivate() {
      this.deactivating = true;
      this.$http
        .post(`organisations/${this.organisation.id}/deactivate`, {
          method: "PUT"
        })
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.notification(
              "Deactivated",
              "Organisation deactivated successfully!",
              "success"
            );
            this.$store.dispatch(actions.LOGOUT).then(() => {
              this.$router.push({ name: "login" });
            });
          }
          this.deactivating = false;
          this.showConfirm = false;
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.deactivating = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.organisation-actions {
  &-action {
    border: 1px solid #9e1531;
    padding: 30px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
